import Vue from 'vue'
import {
  Tabbar,
  TabbarItem,
  Loading,
  NavBar,
  Button,
  Image,
  Field,
  Search,
  Checkbox,
  Uploader,
  Icon,
  Swipe,
  SwipeItem,
  Picker,
  Popup,
  PullRefresh,
  Dialog,
  Tab,
  Tabs,
  Form,
  Radio,
  RadioGroup,
  CheckboxGroup,
  DatetimePicker,
  Cell,
  List
} from 'vant'
import MaterialImage from '@/components/MaterialImage'
import NavigationBar from '@/components/NavigationBar'
import PageContent from '@/components/PageContent'
import NoData from '@/components/NoData'
import AvatarCustom from "@/components/Avatar"
import FilePreviewer from "@/components/FilePreviewer"

Vue.prototype.$confirm = Dialog.confirm

Vue.component(MaterialImage.name, MaterialImage)
Vue.component(NavigationBar.name, NavigationBar)
Vue.component(PageContent.name, PageContent)
Vue.component(NoData.name, NoData)
Vue.component(FilePreviewer.name, FilePreviewer)

Vue.component(Tabbar.name, Tabbar)
Vue.component(TabbarItem.name, TabbarItem)
Vue.component(Loading.name, Loading)
Vue.component(NavBar.name, NavBar)
Vue.component(Button.name, Button)
Vue.component(Image.name, Image)
Vue.component(Field.name, Field)
Vue.component(Search.name, Search)
Vue.component(Checkbox.name, Checkbox)
Vue.component(Uploader.name, Uploader)
Vue.component(Icon.name, Icon)
Vue.component(Swipe.name, Swipe)
Vue.component(SwipeItem.name, SwipeItem)
Vue.component(Picker.name, Picker)
Vue.component(Popup.name, Popup)
Vue.component(PullRefresh.name, PullRefresh)
Vue.component(Dialog.name, Dialog)
Vue.component(Tab.name, Tab)
Vue.component(Tabs.name, Tabs)
Vue.component(Tabs.name, Tabs)
Vue.component(Form.name, Form)
Vue.component(Radio.name, Radio)
Vue.component(RadioGroup.name, RadioGroup)
Vue.component(CheckboxGroup.name, CheckboxGroup)
Vue.component(DatetimePicker.name, DatetimePicker)
Vue.component(Cell.name, Cell)
Vue.component(List.name, List)
Vue.component(AvatarCustom.name, AvatarCustom)
Vue.use(Dialog)




